import React, { useRef } from "react";
import Slider from "react-slick";
import useWindowResize from "../components/hooks/useWindowResize";
import Router, { useRouter } from "next/router";
import Link from "next/link";

const sliderSettings = {
  speed: 200,
  className: "slider variable-width",
  arrows: true,
  dots: false,
  infinite: false,
  centerMode: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  nextArrow: <NextArrow />,
  prevArrow: <PreviousArrow />,
};

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        background: "white",
        color: "white !important",
        borderRadius: "50px",
        paddingLeft: "7px",
        fontSize: "20px",
        height: "20px",
        width: "20px",
        right: "1px",
      }}
      onClick={onClick}
    />
  );
}

function PreviousArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        background: "white",
        color: "white !important",
        borderRadius: "50px",
        paddingLeft: "7px",
        fontSize: "20px",
        height: "20px",
        width: "20px",
        left: "1px",
      }}
      onClick={onClick}
    />
  );
}
export const Sidebar = ({ items = [] }) => {
  const sliderRef = useRef(null);
  const router = useRouter();
  const activeHashName = router.asPath.split(`${router.route}`).pop();
  const windowSize = useWindowResize();
  let isSliderUsed = windowSize["width"] < 768 ? true : false;

  return (
    <ul className={`Sidebar ${isSliderUsed ? "Sidebar--slider" : ""}`}>
      {isSliderUsed ? (
        <Slider style={{ paddingLeft: "20px", paddingRight: "20px" }} ref={sliderRef} {...sliderSettings}>
          {items.map((item, index) => (
            <Link
              style={{ color: "white" }}
              href={`/stats-explained${item?.["link"] ?? "#"}`}
              key={`siderbar-linkm${index + 1}`}
            >
              <button
                style={{ color: "white" }}
                className={`btn btn-primary ${activeHashName === item.link ? "active" : ""}`}
              >
                {item?.["title"] ?? ""}
              </button>
            </Link>
          ))}
        </Slider>
      ) : (
        items.map((item, index) => (
          <li key={`sidebar-link${index + 1}`} className={`${activeHashName === item.link ? "active" : ""}`}>
            <Link href={`/stats-explained${item?.["link"] ?? "#"}`}>
              <p>
                {item.icon ? <span className="mr-2">{item.icon}</span> : null}
                {item["title"]}
              </p>
            </Link>
          </li>
        ))
      )}
    </ul>
  );
};
